import dynamic from 'next/dynamic';
import React from 'react';

// Import ListenLive dynamically with SSR disabled to avoid hydration issues
const ListenLive = dynamic(() => import('./ListenLive'), {
  ssr: false,
  loading: () => (
    <div className="Listen_music" style={{ visibility: 'hidden' }}>
      {/* Placeholder while client-side component loads */}
    </div>
  ),
});

// Types should match the ListenLive component
type Props = {
  colors?: {
    '--global-theme-secondary'?: string;
    '--brand-button-color'?: string;
    '--brand-background-color'?: string;
    '--brand-text-color'?: string;
  };
};

const ListenLiveWrapper: React.FC<Props> = (props) => {
  return <ListenLive {...props} />;
};

export default ListenLiveWrapper;
